/* eslint-disable no-multi-str */
import React from "react"
import styled from "styled-components"
import SectionContainer from "../components/SectionContainer"
import reactLogo from "../images/reactlogo2.png"
import csharpLogo from "../images/csharplogo.png"
import unityLogo from "../images/unitylogo.png"
import CollapsableCard from "../components/CollapsableCard"
import CollapsableIndieHead from "../components/CollapsableIndieHead"
import DropDown from "../components/DropDown"
import SkillTag from "../components/SkillLogoTag"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"

// The First Wave
const TFWHead = () =>
  <CollapsableIndieHead
    projectname="The First Wave"
    description="A 3D browser game"
    time="Nov '20"
  />

const TFWLink = () =>
<>
  <StyledIcon
    icon={faExternalLinkAlt}
  />
  <StyledLink href='https://colorpalette.itch.io/the-first-wave' target='_blank'>
    Check out the game here
  </StyledLink>
</>

const TFWDesc = () =>
  <>
    <div>
      Worked with a 3D artist to create the game. Contains over 11,000 lines of custom C# code, made using the Unity game engine.
    </div>
    <br/>
    <TFWLink/>
  </>

const TFWRelatedTech = () =>
  <>
    <SkillTag
      name='C#'
      icon={csharpLogo}
      proficiency='Proficient'
      standalone
    />
    <SkillTag
      name='Unity'
      icon={unityLogo}
      proficiency='Proficient'
      standalone
    />
  </>

const TFWDetails = () =>
  <DropDown
    description="Created a 3D browser game for a 30 day game jam"
    customtext={<TFWDesc/>}
    relatedtech={<TFWRelatedTech/>}
  />

const TFW = () =>
  <CollapsableCard
    head={<TFWHead/>}
    dropdown={<TFWDetails/>}
  />

// Kuroma
const KuromaHead = () =>
  <CollapsableIndieHead
    projectname="Kuroma"
    description="A color palette prototyping tool"
    time="Oct'20"
  />

const StyledLink = styled.a`
  color: var(--queen-blue);
  text-decoration: none;
  :hover {
    font-weight: bold;
  }
`

const StyledIcon = styled(FontAwesomeIcon)`
  color: var(--gray-text);
  margin-right: 5px;
`

const KuromaLink = () =>
  <>
    <StyledIcon
      icon={faExternalLinkAlt}
    />
    <StyledLink href='https://kuroma-design.web.app' target='_blank'>
      Check out the project
    </StyledLink>
  </>

const KuromaDesc = () =>
  <>
    <div>
      Contains a selection of carefully designed and hand-built components to
      apply the color palettes to, and a rich toolset for crafting and adjusting
      colors and themes.
    </div>
    <br/>
    <KuromaLink/>
  </>

const KuromaRelatedTech = () =>
  <SkillTag
    name='React'
    icon={reactLogo}
    proficiency='Proficient'
    standalone
  />

const KuromaDetails = () =>
  <DropDown
    description="Created a color palette prototyping tool for web designers and developers"
    customtext={<KuromaDesc/>}
    relatedtech={<KuromaRelatedTech/>}
  />

const Kuroma = () =>
  <CollapsableCard
    head={<KuromaHead/>}
    dropdown={<KuromaDetails/>}
  />

const IndependentExp = () => (
  <SectionContainer header="Independent">
    <TFW/>
    <Kuroma/>
  </SectionContainer>
)

export default IndependentExp